module.exports = [{"type":"title","text":"2025-04-25"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USDⓈ-M Futures: Order placement, cancellation, and query now support clientOrderId"},{"type":"html","text":"Spot: balance API endpoint adds displayName field"},{"type":"html","text":"Wallet & Account: Withdrawal API adds 'Spot Account' type"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-04-25.json
// module id = pNhc
// module chunks = 3